import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Analytics } from "@vercel/analytics/react";
import { AnimatePresence } from 'framer-motion';
import Navigation from './components/Navigation';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import TechnologyPage from './pages/TechnologyPage';
import ScannerPage from './pages/ScannerPage';
import BarcodeScannerPage from './pages/BarcodeScannerPage';
import Chatbot from './components/Chatbot';

// ScrollToTop component to handle scrolling to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <main>
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/technology" element={<TechnologyPage />} />
          <Route path="/scanner" element={<ScannerPage />} />
          <Route path="/barcode-scanner" element={<BarcodeScannerPage />} />
        </Routes>
      </main>
    </AnimatePresence>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="bg-gray-900 min-h-screen">
          <Navigation />
          <AppRoutes />
          <Chatbot />
          <Analytics />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;